export default __webpack_public_path__ + "static/media/DharmaGothicE_Heavy_I.51a9837f.otf";